import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

const propTypes = {
  appDynamicsApplicationKey: PropTypes.string,
  enabled: PropTypes.bool,
};

/**
 * adds AppDynamics tags to the document if the feature is enabled.
 *
 * @param {boolean} enabled - boolean to enable tracking
 * @param {string} appDynamicsKey - appDynamicsKey
 */
const EndUserMonitoring = ({
  enabled,
  appDynamicsApplicationKey,
}) => {
  const appDynamicsTag = '/vendor/jsagent/adrum/adrum.js';
  const scripts = [appDynamicsTag];

  let appDynamicsConfig;

  // appDynamics config
  if (enabled && appDynamicsApplicationKey) {
    global.window['adrum-start-time'] = new Date().getTime();
    appDynamicsConfig = global.window['adrum-config'] || {};
    appDynamicsConfig.appKey = appDynamicsApplicationKey;
    appDynamicsConfig.adrumExtUrlHttp = '/vendor/jsagent';
    appDynamicsConfig.adrumExtUrlHttps = '/vendor/jsagent';
    appDynamicsConfig.beaconUrlHttp = 'http://col.eum-appdynamics.com';
    appDynamicsConfig.beaconUrlHttps = 'https://col.eum-appdynamics.com';
    appDynamicsConfig.xd = { enable: false };

    global.window['adrum-config'] = appDynamicsConfig;
  }

  return (
    <Helmet>
      {enabled &&
        scripts.map((script, index) => (
          <script defer key={index} src={script} />
        ))}
    </Helmet>
  );
};

EndUserMonitoring.propTypes = propTypes;

export default EndUserMonitoring;
